import { locationSourceIcon } from '@/ui/locationSourceIcon';
import type { CoordinateLocation, LocationSource } from '@/signalr';
import type { LatLng, MapPoint } from './mapModel';

export type MarkerKind =
  | 'aed'
  | 'callerLocation'
  | 'caller'
  | 'home'
  | 'incident'
  | 'location'
  | 'locationSource';

export type MapMarker = {
  kind: MarkerKind;
  markerId: string;
  latLng: LatLng;
  content: string | null;
  markerIconUrl?: string;
  iconSize?: MapPoint;
  iconAnchor?: MapPoint;
  popupAnchor?: MapPoint;
  locationSource?: LocationSource;
  testID?: string;
};

const LOCATION_SOURCE_ICON_ANCHOR: MapPoint = [15, 22];

export function aedMarker(markerId: string, latLng: LatLng, content: string): MapMarker {
  return { kind: 'aed', markerId, latLng, content, markerIconUrl: 'Images/Icons/map-aed.svg' };
}

export function callerLocationMarker(markerId: string, latLng: LatLng): MapMarker {
  return {
    kind: 'callerLocation',
    markerId,
    latLng,
    content: null,
    markerIconUrl: 'Images/Icons/map-selected.svg',
    iconSize: [49, 70],
    iconAnchor: [24, 60],
    popupAnchor: [0, -62],
    testID: 'incident-map-caller-marker',
  };
}

export function callerMarker(markerId: string, latLng: LatLng): MapMarker {
  return {
    kind: 'caller',
    markerId,
    latLng,
    content: null,
    markerIconUrl: 'Images/Icons/map-caller.svg',
    iconSize: [45, 62],
    iconAnchor: [22, 62],
    popupAnchor: [0, -62],
  };
}

export function homeMarker(markerId: string, latLng: LatLng): MapMarker {
  return { kind: 'home', markerId, latLng, content: null, markerIconUrl: 'Images/Icons/map-home.svg' };
}

export function incidentMarker(markerId: string, latLng: LatLng): MapMarker {
  return { kind: 'incident', markerId, latLng, content: null, markerIconUrl: 'Images/Icons/map-incident.svg' };
}

export function locationMarker(markerId: string, latLng: LatLng, content: string): MapMarker {
  return { kind: 'location', markerId, latLng, content, markerIconUrl: 'Images/Icons/map-icon.svg' };
}

export function locationSourceMarker(source: LocationSource, latLng: LatLng): MapMarker {
  return {
    kind: 'locationSource',
    markerId: `${source}LocationSourceMarker`,
    latLng,
    content: null,
    markerIconUrl: locationSourceIcon(source),
    iconAnchor: LOCATION_SOURCE_ICON_ANCHOR,
    locationSource: source,
  };
}

export function isLocationSourceMarker(marker: MapMarker): boolean {
  return marker.locationSource !== undefined;
}

export function createMarkerBySource(location: CoordinateLocation): MapMarker {
  return locationSourceMarker(location.source, { lat: location.latitude, lng: location.longitude });
}
